var map = {
	"./box.svg": 88552,
	"./close.svg": 49735,
	"./empty-nomsg.svg": 43611,
	"./empty-norecord.svg": 51535,
	"./empty.svg": 46308,
	"./upload.svg": 49494,
	"./wszy-logo-slogan.svg": 26123,
	"./wszy-logo.svg": 44312,
	"./wszy-slogan.svg": 49331,
	"./zljm-logo.svg": 20364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89370;